
export const fromUrl = (props, name = 'id') => Number(props.match.params[name])
export const query = (name) => {
  if (name) {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams) { return urlParams.get(name) }
  }
  return null
}
